import { useState } from "@faire/web/ui/hooks/useState";
import React from "react";
import styled, { RuleSet } from "styled-components";

import { setTimeoutIfPossible } from "@faire/retailer/lib/async-functions/setTimeoutIfPossible";

enum AnimatedState {
  INITIALIZE = 0,
  MOUNTED,
  LOADED,
}

export function animated<T>(Comp: React.ComponentType<T>) {
  return (options: {
    initialStyle: RuleSet<object>;
    mountedStyle?: RuleSet<object>;
    loadedStyle?: RuleSet<object>;
    delay?: number;
  }) => {
    const StyledComp = styled(Comp)<{ state: AnimatedState }>`
      transition: all 0.2s ease;
      ${options.initialStyle};
      ${({ state }) => state >= AnimatedState.MOUNTED && options.mountedStyle};
      ${({ state }) => state >= AnimatedState.LOADED && options.loadedStyle};
    ` as React.ComponentType<T>;

    const AnimatedComponent: React.FC<T> = (props) => {
      const [state, setState] = useState(AnimatedState.INITIALIZE);

      React.useEffect(() => {
        setState(AnimatedState.MOUNTED);
      }, []);

      React.useEffect(() => {
        if (state === AnimatedState.MOUNTED) {
          setTimeoutIfPossible(() => {
            setState(AnimatedState.LOADED);
          }, options.delay ?? 50);
        }
      }, [state]);

      return <StyledComp {...props} state={state} />;
    };
    return AnimatedComponent;
  };
}
